import { action, computed, makeObservable, observable } from 'mobx';
import toast from 'react-hot-toast';
import URLConstants from '../../constants/url-constants';
import config from '../../helpers/config-helper';
import { IAddKishu, IUpdateKishu } from '../../models/forms/IAddUpdateKishu';
import { IOption, IReactSelectOption } from '../../models/ICommon';
import IApiResponse, {
  IApiSuccessResponse,
} from '../../models/response/IApiResponse';
import {
  IKishuList,
  IKishuListVM,
  IKishuVM,
} from '../../models/response/IKishuResponse';
import { IKishuState } from '../../models/state/IKishuState';
import { formatMessage } from '../../translations/format-message';
import {
  GetAllKishuState,
  GetKishuState,
  ObservableInitialState,
} from '../initialState';
import * as baseService from '../service/base-service';
const appConfig = config();

export class KishuMarkStore implements IKishuState {
  initialStateValue = ObservableInitialState;
  kishuList: IKishuListVM = GetAllKishuState;
  kishu: IKishuVM | undefined = undefined;
  kishuState = { ...this.initialStateValue };
  addUpdateKishuState = { ...this.initialStateValue };
  deleteKishuState = { ...this.initialStateValue };
  getAllKishuState = { ...this.initialStateValue };
  getKishuMarkByKishuNameState = { ...this.initialStateValue };
  kishuById: string = '';

  constructor() {
    makeObservable(this, {
      kishu: observable,
      kishuState: observable,
      kishuList: observable,
      addUpdateKishuState: observable,
      deleteKishuState: observable,
      getAllKishuState: observable,
      GetKishuListService: action,
      GetKishuByIdService: action,
      AddKishuService: action,
      UpdateKishuService: action,
      DeleteKishuService: action,
      GetAllKishuService: action,
      resetDeleteKishu: action,
      resetAddUpdateKishuState: action,
      reset: action,
      allKishu: computed,
      kishuDetails: computed,
      allKishuOptions: computed,
      allKishuOptionsNew: computed,
      GetKishuMarkByKishuName: action,
      kishuById: observable,
      getKishuMarkByKishuNameState: observable,
      resetGetKishuMarkByKishuNameState: action,
    });
  }

  //#region Actions
  GetKishuListService = (
    tenantId: number,
    currentPage: number,
    pagerSize: number
  ) => {
    this.getAllKishuState.inProgress = true;
    const url = `${URLConstants.GetAllKishuList}?TenantId=${tenantId}&PageNo=${currentPage}&PageSize=${pagerSize}`;

    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IKishuListVM>>) => {
        if (response.data.Error) {
          this.getAllKishuState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.kishuList = response.data.Data;
          this.getAllKishuState.success = true;
        }
      })
      .catch((err: string) => {
        this.getAllKishuState.error = err;
      })
      .finally(
        action(() => {
          this.getAllKishuState.inProgress = false;
        })
      );
  };

  AddKishuService = (data: IAddKishu) => {
    this.addUpdateKishuState.inProgress = true;
    const url = URLConstants.AddKishu;
    return baseService
      .postRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateKishuState.error = response.data.Message;
        } else {
          this.addUpdateKishuState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateKishuState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateKishuState.inProgress = false;
        })
      );
  };

  UpdateKishuService = (data: IUpdateKishu) => {
    this.addUpdateKishuState.inProgress = true;
    let url = URLConstants.UpdateKishu;
    return baseService
      .putRequest(url, data)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.addUpdateKishuState.error = response.data.Message;
        } else {
          this.addUpdateKishuState.success = true;
        }
      })
      .catch((err: string) => {
        this.addUpdateKishuState.error = err;
      })
      .finally(
        action(() => {
          this.addUpdateKishuState.inProgress = false;
        })
      );
  };

  GetKishuByIdService = (tenantId: number, id: number) => {
    this.kishuState.inProgress = true;
    const url = `${URLConstants.GetKishuById}?TenantId=${tenantId}&Id=${id}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IKishuVM>>) => {
        if (response.data.Error) {
          this.kishuState.error = response.data.Message;
        } else {
          this.kishu = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.kishuState.error = err;
      })
      .finally(
        action(() => {
          this.kishuState.inProgress = false;
        })
      );
  };

  DeleteKishuService = (tenantId: number, id: number) => {
    this.deleteKishuState.inProgress = true;
    const url = `${URLConstants.DeleteKishu}?TenantId=${tenantId}&Id=${id}`;
    return baseService
      .deleteRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<boolean>>) => {
        if (response.data.Error) {
          this.deleteKishuState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else this.deleteKishuState.success = true;
      })
      .catch((err: string) => {
        this.deleteKishuState.error = err;
      })
      .finally(
        action(() => {
          this.deleteKishuState.inProgress = false;
        })
      );
  };

  GetAllKishuService = () => {
    this.getAllKishuState.inProgress = true;
    const url = URLConstants.GetAllKishu;

    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<IKishuListVM>>) => {
        if (response.data.Error) {
          this.getAllKishuState.error = response.data.Message;
          toast.error(formatMessage(response.data.Message));
        } else {
          this.kishuList = response.data.Data;
        }
      })
      .catch((err: string) => {
        this.getAllKishuState.error = err;
      })
      .finally(
        action(() => {
          this.getAllKishuState.inProgress = false;
        })
      );
  };

  GetKishuMarkByKishuName = (tenantId: number, kishu: string) => {
    this.getKishuMarkByKishuNameState.inProgress = true;
    const url = `${URLConstants.GetKishuMarkByKishu}/${tenantId}?Kishu=${kishu}`;
    return baseService
      .getRequest(url)
      .then((response: IApiResponse<IApiSuccessResponse<string>>) => {
        if (response.data.Error) {
          this.getKishuMarkByKishuNameState.error = response.data.Message;
        } else {
          this.kishuById = response.data.Data || '-';
        }
      })
      .catch((err: string) => {
        this.getKishuMarkByKishuNameState.error = err;
      })
      .finally(
        action(() => {
          this.getKishuMarkByKishuNameState.inProgress = false;
        })
      );
  };
  //#endregion

  //#region Computed
  get allKishu(): IKishuList[] {
    let kishuData: IKishuList[] = [];
    if (this.kishuList?.KishuMarks && this.kishuList.KishuMarks?.length > 0) {
      this.kishuList.KishuMarks.map(({ Id, Kishu, KishuMark, Remarks }) => {
        kishuData.push({
          Id,
          Kishu,
          KishuMark: formatMessage(KishuMark),
          Remarks: Remarks || '',
        });
      });
    }
    return kishuData;
  }

  get kishuDetails(): IKishuVM {
    if (this.kishu) {
      return {
        Id: this.kishu.Id,
        Kishu: this.kishu.Kishu,
        KishuMark: this.kishu.KishuMark,
        Remarks: this.kishu.Remarks,
      };
    }
    return {
      Id: -1,
      ...GetKishuState,
    };
  }

  get allKishuOptions(): IReactSelectOption[] {
    let kishuData: IReactSelectOption[] = [];
    kishuData.push({
      label: formatMessage('please_select'),
      value: '-1',
      isDisabled: true,
    });
    if (this.kishuList?.KishuMarks && this.kishuList.KishuMarks?.length > 0) {
      this.kishuList.KishuMarks.map((kishu) => {
        kishuData.push({
          value: String(kishu.Id),
          label: kishu.Kishu,
        });
      });
    }
    return kishuData;
  }

  get allKishuOptionsNew(): IOption[] {
    let kishuData: IOption[] = [];
    kishuData.push({
      id: -1,
      value: 'please_select',
      disabled: true,
    });
    if (this.kishuList?.KishuMarks && this.kishuList.KishuMarks?.length > 0) {
      this.kishuList.KishuMarks.map((kishu) => {
        kishuData.push({
          id: kishu.Id,
          value: kishu.Kishu,
        });
      });
    }
    return kishuData;
  }
  //#endregion

  //#region Reset
  reset = () => {
    this.kishuList = GetAllKishuState;
  };

  resetKishuDetail = () => {
    this.kishu = undefined;
    this.kishuState = { ...this.initialStateValue };
  };

  resetDeleteKishu = () => {
    this.deleteKishuState = { ...this.initialStateValue };
  };

  resetAddUpdateKishuState = () => {
    this.addUpdateKishuState.inProgress = false;
    this.addUpdateKishuState.success = false;
    this.addUpdateKishuState.error = '';
  };

  resetGetKishuMarkByKishuNameState = () => {
    this.getKishuMarkByKishuNameState = { ...this.initialStateValue };
    this.kishuById = '';
  };
  //#endregion
}

export default new KishuMarkStore();
